import {
    BrowserRouter,
    Routes,
    Route,
    Navigate,
    Outlet,
    useLocation,
} from "react-router-dom";
import React from "react";
import { useSelector } from "react-redux";
import Login from "../auth/Login";
import Register from "../auth/Register";
import CreateProfile from "../pages/CreateProfile";
import Layout from "../pages/Layout";
import Home from "../pages/Home";
import ManageSubscription from "../pages/ManageSubscription";
import { Payment } from "../pages/Subscription";
import ScheduleFirstCall from "../pages/ScheduleFirstCall";
import Congratulations from "../pages/Congratulations";
import { AddNewCard } from "../pages/AddNewCard";
import Landing from "../pages/Landing";
import AboutUs from "../pages/AboutUs";
import { getpaymentmethods } from "../collection/ApiCollection";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import TermsAndConditions from "../pages/TermAndCondition";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import Onboarding from "../pages/Onboarding";

// Memoized static route components
const MemoLogin = React.memo(Login);
const MemoRegister = React.memo(Register);
const MemoCreateProfile = React.memo(CreateProfile);
const MemoLayout = React.memo(Layout);
const MemoHome = React.memo(Home);
const MemoManageSubscription = React.memo(ManageSubscription);
const MemoPayment = React.memo(Payment);
const MemoScheduleFirstCall = React.memo(ScheduleFirstCall);
const MemoCongratulations = React.memo(Congratulations);
const MemoAddNewCard = React.memo(AddNewCard);
const MemoLanding = React.memo(Landing);
const MemoAboutUs = React.memo(AboutUs);
const MemoTermsAndConditions = React.memo(TermsAndConditions);
const MemoPrivacyPolicy = React.memo(PrivacyPolicy);
const MemoOnboarding = React.memo(Onboarding);

// --- Route Guards as components ---
function PublicRoute({ isAuthenticated }) {
    const location = useLocation();
    const logindata = useSelector((state) => state?.Authlogin?.data?.userDetail?.isSubUser);
    const logindata2 = useSelector((state) => state?.Authlogin?.data?.userDetail?.isScheduled);
    if (isAuthenticated) {
        return <Navigate to={logindata && logindata2 ? "/landing/home" : logindata ? "/landing/payment" : "/landing/create-profile"} replace />;
    }
    return <Outlet />;
}

function PrivateRoute({ isAuthenticated }) {
    if (!isAuthenticated) return <Navigate to="/" replace />;
    return <Outlet />;
}

export default function WebRoutes() {
    const isAutharised = useSelector((state) => state?.Authlogin?.data?.token);
    const isSubUser = useSelector((state) => state?.Authlogin?.data?.userDetail?.isSubUser);

    console.log(isSubUser, "isSubUser")
    // const [cardListing, setCardListing] = useState(null);
    const pathname = window.location.pathname == "/landing/create-profile";
    // console.log(cardListing, "cardListing", pathname)

    // const handleGetAllCard = async () => {
    //     try {
    //         let res = await getpaymentmethods();
    //         if (res.status === 200) {
    //             setCardListing(res?.data?.data)
    //         } else {
    //             setCardListing(null)
    //         }
    //     } catch (error) {
    //         setCardListing(null)
    //     }
    // }

    // useEffect(() => {
    //     handleGetAllCard()
    // }, [])

    // useEffect(() => {
    //     if (cardListing?.[0]?.isDefault && pathname === "/landing/payment") {
    //         window.location.replace("/landing/schedule");
    //     }
    // }, [cardListing, pathname]); // Added dependencies to ensure reactivity

    useEffect(() => {
        if (pathname && isSubUser) {
            window.location.replace("/landing/payment");
        }
    }, [isSubUser, window.location])


    return (
        <BrowserRouter>
            <Routes>
                {/* Public routes */}
                <Route element={<PublicRoute isAuthenticated={isAutharised} />}>
                    <Route element={<MemoLanding />} path="/" />
                    <Route element={<MemoLogin />} path="/login" />
                    <Route element={<MemoRegister />} path="/register" />
                    <Route element={<MemoAboutUs />} path="/about" />
                    <Route element={<MemoTermsAndConditions />} path="/landing/conditions" />
                    <Route element={<MemoPrivacyPolicy />} path="/landing/policy" />
                    <Route element={<MemoOnboarding />} path="/onboarding" />
                </Route>
                {/* Private routes */}
                <Route element={<PrivateRoute isAuthenticated={isAutharised} />}>
                    <Route element={<MemoLayout />} path="/landing">
                        <Route element={<MemoHome />} path="/landing/home" />
                        <Route element={<MemoPayment />} path="/landing/payment" />
                        <Route element={<MemoAddNewCard />} path="/landing/add-new-card" />
                        <Route element={<MemoScheduleFirstCall />} path="/landing/schedule" />
                        <Route element={<MemoManageSubscription />} path="/landing/manage-subscription" />
                        <Route element={<MemoCreateProfile />} path="/landing/create-profile" />
                        <Route element={<MemoCongratulations />} path="/landing/congratulations" />
                    </Route>
                </Route>
            </Routes>
        </BrowserRouter>
    );
}
